__turbopack_context__.v({
  "bgShow": "InteractiveMapDesktop-module-scss-module__jnzA_W__bgShow",
  "bgStyle": "InteractiveMapDesktop-module-scss-module__jnzA_W__bgStyle",
  "compass": "InteractiveMapDesktop-module-scss-module__jnzA_W__compass",
  "compass__icon": "InteractiveMapDesktop-module-scss-module__jnzA_W__compass__icon",
  "compass_c": "InteractiveMapDesktop-module-scss-module__jnzA_W__compass_c",
  "cursorAuto": "InteractiveMapDesktop-module-scss-module__jnzA_W__cursorAuto",
  "customContainer": "InteractiveMapDesktop-module-scss-module__jnzA_W__customContainer",
  "customContainerContentTitle": "InteractiveMapDesktop-module-scss-module__jnzA_W__customContainerContentTitle",
  "d2": "InteractiveMapDesktop-module-scss-module__jnzA_W__d2",
  "ekoRoad": "InteractiveMapDesktop-module-scss-module__jnzA_W__ekoRoad",
  "ekoRoadLine": "InteractiveMapDesktop-module-scss-module__jnzA_W__ekoRoadLine",
  "ekoRoadLine__svg": "InteractiveMapDesktop-module-scss-module__jnzA_W__ekoRoadLine__svg",
  "introInner": "InteractiveMapDesktop-module-scss-module__jnzA_W__introInner",
  "man": "InteractiveMapDesktop-module-scss-module__jnzA_W__man",
  "mapBlock": "InteractiveMapDesktop-module-scss-module__jnzA_W__mapBlock",
  "mapBox": "InteractiveMapDesktop-module-scss-module__jnzA_W__mapBox",
  "mck": "InteractiveMapDesktop-module-scss-module__jnzA_W__mck",
  "park": "InteractiveMapDesktop-module-scss-module__jnzA_W__park",
  "park2": "InteractiveMapDesktop-module-scss-module__jnzA_W__park2",
  "road": "InteractiveMapDesktop-module-scss-module__jnzA_W__road",
  "school": "InteractiveMapDesktop-module-scss-module__jnzA_W__school",
  "scrollDescriptionIcon": "InteractiveMapDesktop-module-scss-module__jnzA_W__scrollDescriptionIcon",
  "stage": "InteractiveMapDesktop-module-scss-module__jnzA_W__stage",
  "stage__buildings": "InteractiveMapDesktop-module-scss-module__jnzA_W__stage__buildings",
  "stage__hidden": "InteractiveMapDesktop-module-scss-module__jnzA_W__stage__hidden",
  "stage__one": "InteractiveMapDesktop-module-scss-module__jnzA_W__stage__one",
  "stage__three": "InteractiveMapDesktop-module-scss-module__jnzA_W__stage__three",
  "stage__two": "InteractiveMapDesktop-module-scss-module__jnzA_W__stage__two",
  "stage__twoOne": "InteractiveMapDesktop-module-scss-module__jnzA_W__stage__twoOne",
  "stage__twoThree": "InteractiveMapDesktop-module-scss-module__jnzA_W__stage__twoThree",
  "stage__twoTwo": "InteractiveMapDesktop-module-scss-module__jnzA_W__stage__twoTwo",
  "stage__visible": "InteractiveMapDesktop-module-scss-module__jnzA_W__stage__visible",
  "textBlock": "InteractiveMapDesktop-module-scss-module__jnzA_W__textBlock",
  "verticalDivider": "InteractiveMapDesktop-module-scss-module__jnzA_W__verticalDivider",
  "verticalDividerMck": "InteractiveMapDesktop-module-scss-module__jnzA_W__verticalDividerMck",
});
